export default "__VITE_ASSET__DpZu$SS$__"